import React, { useState } from 'react';
import './LoginForm.css';

export default function LoginForm({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Clear any previous errors

        try {
            const userData = await onLogin(username, password); // Call onLogin with username and password
            if (userData?.token) {
                localStorage.setItem("accessToken", userData.token); // Store token
                window.location.reload(); // Refresh UI to reflect login state
            } else {
                setError("Invalid login response. No token received.");
            }
            // Handle successful login (redirect or update state)
           
        } catch (err) {
            setError(err.message); // Display error message
        }
    };

    return (
        <div className="login_form">
             <h1>BeepoBUY</h1>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Adresse e-mail:</label>
                    <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Mot de passe:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <div className="error">{error}</div>}
                <div className="create_account_div">
                    Première connexion? <a href="/anonymous/create_client">Créer mon compte</a>  |  <a href="/forgot-password">J'ai oublié mon mot de passe</a>
                </div>
                <div className="form-group">
                    <button type="submit">Connexion</button>
                </div>
            </form>
        </div>
    );
}
